import request from '@/router/axios'

export function getPage(params) {
    return request({
        url: '/chain/companysettle/pageList',
        method: 'get',
        params
    })
}
export function batchAddWaybillSettle(data) {
    return request({
        url: '/chain/companysettle/batchAddWaybillSettle',
        method: 'post',
        data
    })
}

export function captainWaybillListExport(data) {
    return request({
        url: '/chain/companywaybill/captainWaybillListExport',
        method: 'post',
        data
    })
}
